export default __webpack_public_path__ + "static/media/brand_bg02.a2e1e172.jpg";